export default __webpack_public_path__ + "static/media/caregiver-platinum-badge.659551bb.svg";